export default __webpack_public_path__ + "static/media/duster-techroad-medium2.b1ecbc0e.jpg";